<template>
  <v-container fluid>
    <page-title icon="fas fa-fw fa-tags">
      Labels
      <template v-slot:buttons>
        <v-btn v-if="1===2"
               color="Secondary"
               href="https://docs.mobilelocker.com/docs/labels"
               target="_blank"
               class="mr-4">
          Tutorial
        </v-btn>
        <v-btn color="primary"
               :to="{name: 'admin.labels.create'}">
          New Label
        </v-btn>
      </template>
    </page-title>

    <v-row>
      <v-col cols="3">
        <v-form>
          <v-card>
            <v-card-title class="pb-0">
              Filter
            </v-card-title>
            <v-card-text>
              <v-checkbox v-model="form.showPresentations"
                          label="Show presentations"
                          dense
                          hide-details>
              </v-checkbox>

              <v-checkbox v-model="form.showGroups"
                          label="Show groups"
                          dense
                          hide-details>
              </v-checkbox>

              <v-text-field v-model="form.labelName"
                            type="text"
                            label="Label name"
                            placeholder="Label Name Contains"
                            clearable>
              </v-text-field>

              <v-autocomplete v-model="form.presentation_id"
                              label="Presentation"
                              :items="presentations"
                              item-value="id"
                              item-text="name"
                              clearable>
              </v-autocomplete>

              <v-autocomplete v-model="form.group_id"
                              label="Group"
                              :items="groups"
                              item-value="id"
                              item-text="name"
                              clearable>
              </v-autocomplete>


            </v-card-text>
            <v-card-actions>
              <v-btn color="primary"
                     @click.prevent="resetForm">
                Reset
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="9">

        <v-card class="mb-4">
          <v-toolbar color="primary"
                     dark
                     flat>
            <v-toolbar-title>
              {{ labels.length | pluralize('Label') }}
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text class="text-left">
            <strong>Tip:</strong> Organize your presentations applying labels (or tags) so your team can find them
            easily in the app.
            <br>
            <strong>Examples:</strong> Brochures Forms Training Product Spec Sheets Videos English French German
          </v-card-text>

          <v-card-actions>

            <v-row>
              <v-col cols="12"
                     lg="4">
              </v-col>
            </v-row>

          </v-card-actions>
        </v-card>

        <div>
          <div v-for="label in filteredLabels"
               :key="label.id">

            <v-card class="mb-4">
              <v-card-title class="d-flex justify-space-between">
                <div>
                  {{ label.name }}
                </div>
                <div>
                  <v-btn :to="{name: 'admin.labels.edit', params: {labelID: label.id}}"
                         x-small>
                    Edit
                  </v-btn>
                </div>
              </v-card-title>

              <v-card-text v-if="form.showPresentations || form.showGroups">


                <template v-if="form.showPresentations">
                  <v-card-subtitle class="py-0 pl-0">
                    {{ label.presentations.length | pluralize('presentation') }}:
                  </v-card-subtitle>
                  <v-list class="my-0"
                          dense>
                    <template v-for="presentation in sortedPresentations(label)">
                      <v-list-item :key="presentation.id"
                                   class="pl-0">
                        <v-list-item-content>
                          <v-list-item-title>
                            <div style="display:flex; justify-content: space-between">
                              <div>
                                {{ presentation.name }}
                              </div>
                            </div>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider></v-divider>
                    </template>
                  </v-list>
                </template>

                <template v-if="form.showGroups">
                  <v-card-subtitle class="py-0 pl-0">
                    {{ label.groups.length | pluralize('group') }}:
                  </v-card-subtitle>
                  <v-list class="my-0"
                          dense>
                    <template v-for="group in sortedGroups(label)">
                      <v-list-item :key="group.id"
                                   class="pl-0">
                        <v-list-item-content>
                          <v-list-item-title>
                            <div style="display:flex; justify-content: space-between">
                              <div>
                                {{ group.name }}
                              </div>
                            </div>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider></v-divider>
                    </template>
                  </v-list>
                </template>
              </v-card-text>
            </v-card>

          </div>
        </div>
      </v-col>
    </v-row>


    <pre>{{  }}</pre>


  </v-container>
</template>
<script>
import {mapGetters} from 'vuex';
import {Form} from 'vform';
import {find, orderBy} from "lodash";
import PageTitle from '../../components/PageTitle.vue';

export default {
  components: {PageTitle},
  metaInfo() {
    this.$store.commit('setTitle', 'Labels');
    return {
      title: this.$store.getters.title,
    }
  },
  data() {
    return {
      breadcrumbs: [
        {text: 'Labels', disabled: false, exact: true, to: {name: 'admin.labels'}},
        {text: 'List'}
      ],
      form: new Form({
        showPresentations: false,
        showGroups: false,
        labelName: '',
        group_id: '',
        presentation_id: '',
      }),
      loading: false,
    }
  },
  computed: {
    ...mapGetters([
      'groups',
      'presentations',
      'team',
      'labels',

    ]),
    filter: function () {
      if (this.form.labelName?.length === 0 && !this.form.presentation_id && !this.form.group_id) {
        return false;
      }
      return {
        labelName: this.form.labelName?.toLowerCase().trim(),
        presentation_id: (this.form.presentation_id) ? parseInt(this.form.presentation_id) : null,
        group_id: (this.form.group_id) ? parseInt(this.form.group_id) : null,
      };
    },
    filteredLabels: function () {
      const filter = this.filter;
      if (!filter) {
        return this.labels;
      }
      return this.labels.filter(l => {
        if (filter.labelName && l.name.toLowerCase().indexOf(filter.labelName) === -1) {
          return false;
        }
        if (filter.group_id) {
          let g = find(l.groups, g => g.id === filter.group_id);
          if (!g) {
            return false;
          }
        }
        if (filter.presentation_id) {
          let p = find(l.presentations, p => p.id === filter.presentation_id);
          if (!p) {
            return false;
          }
        }
        return true;
      });
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      //await this.$store.dispatch('fetchGroups');
      this.loading = false;
    },
    resetForm() {
      this.form.showPresentations = false;
      this.form.showGroups = false;
      this.form.labelName = '';
      this.form.group_id = '';
      this.form.presentation_id = '';
    },

    sortedPresentations(label) {
      return orderBy(label.presentations, ['slug', 'id'], ['asc', 'asc']);
    },
    sortedGroups(label) {
      return orderBy(label.groups, ['slug', 'id'], ['asc', 'asc']);
    },

  }
}
</script>

